import styled from 'styled-components'

import { SwiperSlide as SwiperSlideLib } from 'swiper/react'

interface AreaSlideProps {
  maxW?: number
}

export const AreaSlide = styled.div<AreaSlideProps>`
  max-width: ${({ maxW }) => (maxW ? `${maxW - 24}px` : '100%')};
  padding-right: 0.5;
  position: relative;

  .swiper-pagination-bullets {
    display: none;
  }

  .swiper-wrapper {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }

  .swiper-slide {
    background-color: white;
    border-radius: 0.5rem;
    height: auto !important;
    max-width: fit-content;
    min-width: 280px !important;
    width: 280px !important;
    position: relative;
    transition: transform 0.3s ease 0.1s;

    &:hover {
      transform: translateY(-0.5rem);
    }
  }
`

export const SwiperSlide = styled(SwiperSlideLib)`
  flex: 1;
`
